import Axios from "axios";
import React from "react";
import GithubProfile from "./GithubProfile";
import { clientId } from "./GithubCredentials";
import { clientSecret } from "./GithubCredentials";
import GithubRepos from "./GithubRepos";
class GithubAPI extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            username : '',
            profile :null,
            repos : null
        }
    }

    updateInput = (event) =>{ 
        this.setState({
            ...this.state,
            username  : event.target.value
        })
    }

    searchProfile = () => {
        let url=`https://api.github.com/users/${this.state.username}?clientId=${clientId}&clientSecret=${clientSecret}`
        Axios.get(url)
        .then((response) => {
            this.setState({
                profile : response.data
            })

        }).catch((error) => {
            console.log(error);
        })
    }

    searchRepos = () => {
        let url=`https://api.github.com/users/${this.state.username}/repos?clientId=${clientId}&clientSecret=${clientSecret}`
        Axios.get(url)
        .then((response) => {
            this.setState({
                repos : response.data
            })

        }).catch((error) => {
            console.log(error);
        })
    }

    searchUser = (event) => {
        event.preventDefault();
        this.searchProfile();
        this.searchRepos();
    }
    render(){
        return(
            <>
              <div className="container mt-3">
                  <div className="row">
                     <div className="col">
                         <div className="card">
                              <div className="card-header bg-secondary text-white">
                                <h3>Github User Search</h3>
                              </div>
                              <div className="card-body">
                                 <form className="form-inline " onSubmit={this.searchUser}>
                                      <div className="form-group">
                                           <input onChange={this.updateInput} value={this.state.username} size={40} type='text' className="form-control" placeholder="User Name" />
                                      </div>
                                      <div>
                                          <input type="submit" value="Search" className="btn btn-secondary mx-2 btn-sm" />
                                      </div>
                                 </form>
                              </div>
                         </div>
                     </div>
                  </div>
              </div>

              <div className="container mt-3">
                     <div className="row">
                         <div className="col">
                              {
                                this.state.profile  ? <GithubProfile profile={this.state.profile}/>
                                : null
                              }
                         </div>
                     </div>
              </div>

              <div className="container mt-3">
                     <div className="row">
                         <div className="col">
                              {
                                this.state.repos  ? <GithubRepos repos={this.state.repos}/>
                                : null
                              }
                         </div>
                     </div>
              </div>

              
            </>
        )
    }
}

export default GithubAPI
